import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import Label from 'common/typography/Label/Label';
import Button from 'common/components/atoms/Button';
import FlexContainer from 'common/components/atoms/FlexContainer';
import Modal from 'common/components/organisms/ModalV2';
import InputField from 'common/components/atoms/InputField';

import * as sensorActions from '../actions/sensors.actions';
import { useOrganisationSiteOptions } from '../hooks/useSiteReassign';

const CancelButton = styled(Button)`
  margin-right: 20px;
`;

const DropdownContainer = styled.div`
  width: 60%;
`;

function ReassignToSiteModal({
  orgId,
  deviceCount,
  deviceAccountIds,
  close,
  onConfirm,
  sensorActions: actions,
  t,
}) {
  const [target_account_id, setTargetAccountId] = useState('');
  const { siteOptions, loading } = useOrganisationSiteOptions(
    orgId,
    actions.getOrganisationSites
  );

  const allDevicesAlreadyOnTarget = Boolean(
    target_account_id
    && deviceAccountIds.length > 0
    && deviceAccountIds.every(id => String(id) === String(target_account_id))
  );

  return (
    <Modal width="600px" padding="0 20px" close={close}>
      <FlexContainer direction="column" marginbottom="40px" margintop="40px">
        <FlexContainer direction="column" alignItems="center" marginbottom="40px">
          <Label fontWeight="300" fontSize="18px" marginBottom="8px">
            {t('sensors.reassignSite.prompt')}
          </Label>
          <Label fontSize="14px" marginBottom="0px">
            {t('sensors.reassignSite.deviceCount', { count: deviceCount })}
          </Label>
        </FlexContainer>
        <FlexContainer justifyContent="center" marginbottom="8px">
          <DropdownContainer>
            <InputField
              label={t('sensors.reassignSite.siteLabel')}
              onChange={(e, d) => setTargetAccountId(d.value)}
              placeholder={
                loading
                  ? t('sensors.reassignSite.loadingPlaceholder')
                  : t('sensors.reassignSite.sitePlaceholder')
              }
              type="select"
              search
              value={target_account_id}
              options={siteOptions}
            />
          </DropdownContainer>
        </FlexContainer>
        <FlexContainer justifyContent="center">
          <CancelButton onClick={close} secondary="#000">
            {t('sensors.reassignSite.cancel')}
          </CancelButton>
          <Button
            disabled={!target_account_id || loading || allDevicesAlreadyOnTarget}
            onClick={() => onConfirm(target_account_id)}
          >
            {t('sensors.reassignSite.confirm')}
          </Button>
        </FlexContainer>
      </FlexContainer>
    </Modal>
  );
}

ReassignToSiteModal.propTypes = {
  orgId: PropTypes.number.isRequired,
  deviceCount: PropTypes.number.isRequired,
  deviceAccountIds: PropTypes.arrayOf(PropTypes.number),
  close: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  sensorActions: PropTypes.shape({
    getOrganisationSites: PropTypes.func.isRequired,
  }).isRequired,
};

ReassignToSiteModal.defaultProps = {
  deviceAccountIds: [],
};

const mapDispatchToProps = dispatch => ({
  sensorActions: bindActionCreators(sensorActions, dispatch),
});

export default connect(null, mapDispatchToProps)(withTranslation()(ReassignToSiteModal));
